import { getGameType } from "@/api/game.module";

export default [
  {
    path: "/activity-2023/game",
    component: () =>
      import(
        /* webpackChunkName: 'game-index' */ "@/views/common/game/index.vue"
      ),
    async beforeEnter(to, from, next) {
      const { data } = await getGameType();
      switch (data.game_type) {
        case 0:
          if (to.name !== "game-iceberg") {
            next({ name: "game-iceberg" });
          }
          break;
        case 1:
          if (to.name !== "fruit-scoop") {
            next({ name: "fruit-scoop" });
          }

          break;
        case 2:
          if (to.name !== "game-bombs") {
            next({ name: "game-bombs" });
          }

          break;
        default:
          next();
          return;
      }
      next();
    },
    children: [
      {
        path: "/activity-2023/game/game-iceberg",
        name: "game-iceberg",
        component: () =>
          import(
            /* webpackChunkName: 'game-iceberg' */ `@/views/common/game/iceberg/voice-room.vue`
          ),
      },
      {
        path: "/activity-2023/game/fruit-scoop",
        name: "fruit-scoop",
        component: () =>
          import(
            /* webpackChunkName: 'game-fruit-scoop' */ "@/views/common/game/fruit-scoop/index.vue"
          ),
      },
      {
        path: "/activity-2023/game/bombs",
        name: "game-bombs",
        component: () =>
          import(
            /* webpackChunkName: 'game-bombs' */ "@/views/common/game/bombs/index.vue"
          ),
      },
    ],
  },
  {
    path: "/activity-2023/game/game-iceberg",
    component: () =>
      import(
        /* webpackChunkName: 'game' */ `@/views/common/game/iceberg/voice-room.vue`
      ),
  },
  {
    path: "/activity-2023/game/fruit-scoop",
    component: () =>
      import(
        /* webpackChunkName: 'fruit-scoop' */ "@/views/common/game/fruit-scoop/index.vue"
      ),
  },
  {
    path: "/activity-2023/game/coins",
    component: () =>
      import(
        /* webpackChunkName: 'coin-detail' */ `@/views/common/game/coin-detail.vue`
      ),
    meta: {
      title: "代币记录",
    },
  },
  {
    path: "/activity-2023/game/bombs",
    name: "bombs",
    component: () =>
      import(
        /* webpackChunkName: 'bombs' */ "@/views/common/game/bombs/index.vue"
      ),
  },
];
